import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { RequestPayload } from 'src/app/models/request-payload';
import { ApiConfigurationService } from 'src/app/services/api-configuration.service';
import { ClassifiedService } from 'src/app/services/classified.service';
import { CommonService } from 'src/app/services/common.service';
import { LocalService } from 'src/app/services/local.service';
import { NameWhiteSpace } from 'src/app/services/nameWhiteSpace.validator';
declare var $;
@Component({
  selector: 'app-email-approval-inbox',
  templateUrl: './email-approval-inbox.component.html',
  styleUrls: ['./email-approval-inbox.component.scss']
})
export class EmailApprovalInboxComponent {

  payload:any;
  requestPayload:RequestPayload = Object();
  accesskeyValidation:any=false;
  selectedActionItem:any="";
  buttonActionType:any="";
  approvalForm:FormGroup;
  wfInboxData:any=[];

constructor(private route: ActivatedRoute,
    private cookieService:CookieService,private localService:LocalService,private toaster:ToastrService,
  private apiConfig:ApiConfigurationService,private commonService:CommonService,private formBuilder:FormBuilder,
private classifiedService:ClassifiedService){
    this.approvalForm = this.formBuilder.group({
            approvalType:['',[Validators.required]],
            comments:['',[Validators.required,NameWhiteSpace.noSpaceAllowed]]
          })
    }

    ngOnInit(): void {
      this.route.queryParams.subscribe(params => {
        this.payload = {
          orderId: params['orderId'],
          itemId: params['itemId'],
          inboxId: params['inboxId'],
          inboxMasterId: params['inboxMasterId'],
          objectRefId: params['objectRefId'],
          accessObjectId: params['accessObjectId'],
          accessKey: params['accessKey']
        };
        this.validateAccessKey();
      });
    }

    async validateAccessKey(){
      this.wfInboxData=[];
      let res = await this.validateKey(this.payload);
      if(res.status == 0){
        this.accesskeyValidation = true;
        this.wfInboxData = res.data;
        $("#confirmApprovalModal").modal("show");
        // this.paymentService.billDeskCreateOrder(this.cartItemsData);
      }else{
        this.toaster.warning(res.message);
      }
    }
  
    async validateKey(payload){
      let url:any =this.apiConfig.getRequiredApi("validate_access_key");
      this.requestPayload.url = url;
      this.requestPayload.body = payload;
      let data:any = this.commonService.postData(this.requestPayload);
      return await data.toPromise();
    }

    submitConfirmModal(){
      if(this.buttonActionType!='bulk'){
        this.actionApprove(this.payload);
        this.closeModal('confirmApprovalModal');
      }
    }

    actionApprove(item){
      let payload:any=Object();
      payload['itemId']=item.itemId;
      payload['orderId']=item.orderId;
      payload['currentLevel'] = item.currentLevel;
      payload['inboxId'] = item.inboxId;
      payload['noOflevels'] =item.noOfLevels;
      payload['bookingOffice'] = item.bookingOffice;
      payload['action']=this.approvalForm.value['approvalType'];
      payload['actionComments']=this.approvalForm.value['comments'];
      payload['agreedPremiumDisPer'] = item.agreedPremiumDisPer;
      payload['inboxMasterId'] = item.inboxMasterId;
      payload['objectRefId'] = item.objectRefId;
      payload['refToUser'] = this.wfInboxData.refToUsers;
      this.classifiedService.approoveWfInboxByEmail(payload).subscribe(res=>{
        if(res!=null && res.status==0){
          this.toaster.success(res.message);
         
          // this.getRmsInboxList();
        }else{
          this.toaster.warning(res.message);
        }
      });
    }

    closeModal(id){
      $("#"+id).modal('hide');
    }

    isSubmitDisabled(): boolean {
      const approvalType = this.approvalForm.get('approvalType')?.value;
      const comments = this.approvalForm.get('comments')?.value;    
      if (approvalType === 'APPROVED') {
        return false;
      }    
      if (approvalType === 'REJECTED') {
        return !comments; 
      } 
  
      return !this.approvalForm.valid; 
    }
}
